import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import {Sector} from './../../../../node_modules/gci-data-api/';
import { SectorSaverPage } from './sector-saver/sector-saver.page';

function stringDate(d:any){
  if(!d) return '';
  d = new Date(d);
  if(isNaN(d)) return '';
  return `${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()}`;
}

function eqSet(as, bs) {
    return as.size === bs.size && all(isIn(bs), as);
}

function all(pred, as) {
    for (var a of as) if (!pred(a)) return false;
    return true;
}

function isIn(as) {
    return function (a) {
        return as.has(a);
    };
}

@Component({
  selector: 'app-sector-editor',
  templateUrl: './sector-editor.component.html',
  styleUrls: ['./sector-editor.component.scss'],
})
export class SectorEditorComponent implements OnInit {
  @ViewChild("newTeamInput", { read: ElementRef }) newTeamInput: ElementRef;
  @Output() saveSector:EventEmitter<any> = new EventEmitter<any>();
  initialTeams:any[]=[];
  initialRoads:any[]=[];
  initialRoadInfo:any={};
  @Input() set sector( value:Sector){
    console.log('set sctor',value)
    if(!value){
      this._sector = undefined;
      return;
    }
    if(value){
      const sector = value.toJSON();
      this._sector = sector;
      this.initialTeams = [...this._sector.teams];
      this.initialRoads = [...this._sector.roads];
      if(!this.initialRoadInfo ){
        this.initialRoadInfo = Object.freeze(Object.assign({},{...this._sector.roadInfo}));
        console.log('SET initialRoadInfo',this.initialRoadInfo)

      }
      this.reset();
    }
  };
  get teams():string[]{
    return this._sector ? this._sector.teams||[] : [];
  }
  get roads():string[]{
    return this._sector ? this._sector.roads||[] : [];
  }
  _sector:any;
  form:FormGroup;
  roadInfoChanges:any;
  roadInfo:any;
  constructor(private formBuilder: FormBuilder,public modalController: ModalController ) {
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      created: ['', Validators.required],
      status: ['', Validators.required],
      teams:[[], Validators.minLength(1)],
      roads: [[], Validators.minLength(1)],
      roadInfo: [{}]
    });
   }

  async reset(){
    const allNumbers = this._sector.roads||[];
    const currentIfo = this._sector.roadInfo;
    Object.keys(currentIfo).forEach( ( number )=>{
      if(!allNumbers.includes(number)){
        allNumbers.push(number);
      }
    })
    allNumbers.forEach( ( number )=>{
      if(!currentIfo[number]){
        currentIfo[number]={number};
      }
    });

    this.roadInfo=currentIfo;
    this.form.controls['name'].setValue(this._sector.name);
    this.form.controls['created'].setValue( new Date(this._sector.created));
    this.form.controls['status'].setValue(this._sector.status);
    this.form.controls['teams'].setValue(this._sector.teams||[]);
    this.form.controls['roads'].setValue(allNumbers||[]);
    this.form.controls['roadInfo'].setValue(currentIfo);

  }
  get valid(){
    if(!this.form.controls) return true;
    if(!this._sector) return true;

    let value = this.form.value||{};
    let changes:boolean[] = [
      (value['name'] != this._sector.name),
      (stringDate(value['created']) != stringDate(this._sector.created)),
      (value['status'] != this._sector.status)
    ];

    let formTeams = (this.form.value.teams||[]).sort().join('|');
    let formRoads = (this.form.value.roads||[]).sort().join('|');
    let sectorTeams = (this.initialTeams||[]).sort().join('|');
    let sectorRoads = (this.initialRoads||[]).sort().join('|');
    // console.log(formTeams,sectorTeams)
    if(formTeams != sectorTeams){
      changes.push( true );
    }
    if(formRoads != sectorRoads){
      changes.push( true );
    }
    if(this.roadInfoChanges){
      // console.log('roadInfoChanges')
      changes.push(true );
    }
    let hasChanges = changes.some( (c:boolean)=>{
      return !!c;
    });
    return this.form.valid && hasChanges;
  }
  onRoadInfoChanged(info:any){
    if(!info) return;
    if(!this._sector) return;
    console.log('secctinr road chagnes true', info['111'])
    this.roadInfoChanges = true;
    // this._sector.roads = Object.keys(info);
    // this.form.controls['roadInfo'].setValue({...this._sector.roadInfo});
    console.log('GG',this._sector.roadInfo['111'],this.initialRoadInfo['111'])
    this.form.controls['roads'].setValue(Object.keys(info));
  }

  ngOnInit() {}
  addRoad(data:{number:string,season:string,year:string|number}){
    const name = data.number.toUpperCase();
    data.number = name;
    const exists:boolean = !!~this._sector.roads.indexOf(name);
    if(!exists){
      this._sector.roads.push(name);

    }
    if(!this._sector.roadInfo){
      this._sector.roadInfo = {};
    }
    this._sector.roadInfo[name]=data;
    this.form.controls['roadInfo'].setValue(this._sector.roadInfo);
  }

  removeRoad(name:string){
    const foundIndex = this._sector.roads.indexOf(name);
    if(~foundIndex){
      this._sector.roads.splice(foundIndex,1);
      this.form.controls['roads'].setValue(this._sector.roads);
    }
    if(!this._sector.roads.length){
      this.form.controls['roads'].setErrors({'incorrect': true});
    }
    // console.log('removeRoad',name);
  }
  async openSaver(){

    const props = {original:{...this._sector},data:this.form.value};
    props.original.teams = this.initialTeams;
    props.original.roads = this.initialRoads;
    props.original.roadInfo = this.initialRoadInfo;
    console.log({initialRoadInfo:this.initialRoadInfo['111'],sector: this._sector.roadInfo['111'],data:this.form.value.roadInfo['111']})
    const modal = await this.modalController.create({
      component: SectorSaverPage,
      cssClass: 'sector-saver-modal',
      componentProps: props
    });
    await modal.present();
    const  {data} = await modal.onWillDismiss();
    if(data && data.confirmed){
      this.saveSector.emit(  props );
    }
  }


  computeRoadInfo(road:string){
    const info = Object.assign({number:'...',season:'.',year:'.'}, this._sector.roadInfo[road]);
    const {number,season,year} = info;

    return `(${number}${season}${year})`;
  }
  addTeam(name:any){
    // console.log('addteam',name);
    name = String(name).toUpperCase();
    const exists:boolean = !!~this._sector.teams.indexOf(name);
    if(!exists){
      this._sector.teams.push(name);
      this.form.controls['teams'].setValue(this._sector.teams);

    }
    this.newTeamInput.nativeElement.value='';
  }
  removeTeam(name:any){
    name = String(name).toUpperCase();
    const foundIndex = this._sector.teams.indexOf(name);
    if(~foundIndex){
      this._sector.teams.splice(foundIndex,1);
      this.form.controls['teams'].setValue(this._sector.teams);
    }
    if(!this._sector.teams.length){
      this.form.controls['teams'].setErrors({'incorrect': true});
    }
    // console.log('removeteam',name);
  }
  save(){
    if(this.form.valid){

      this.openSaver();
    }
    // console.log(this.form.valid, this.form.value)
  }

}
